import React, { forwardRef } from 'react';

import Button from '@atlaskit/button/standard-button';
import type { Appearance } from '@atlaskit/button/types';

export type Props = {
	appearance?: Appearance;
	iconBefore?: React.ReactChild;
	isLoading?: boolean;
	isSelected?: boolean;
	isDisabled?: boolean;
	onClick: (e: React.MouseEvent<HTMLElement>) => void;
	text?: React.ReactNode;
	autoFocus?: boolean;
	'aria-haspopup'?: boolean;
};

export const ShareButton = forwardRef<HTMLElement, Props>(
	({ text, 'aria-haspopup': _ariaHasPopup, ...props }: Props, ref) => {
		return (
			<Button
				id="share-trigger-btn"
				// TODO: update to correct test id during fg (move_share_dialog_to_jira) cleanup
				// Temporarily keeping this test ID aligned with pre-share-view
				// so existing issue view Cypress tests still run and ensure our migration
				// is not breaking anything.
				// On cleanup, update all related test IDs under:
				//   - jira/src/packages/issue/page-objects
				//   - jira/src/packages/issue/playwright-page-objects
				// eslint-disable-next-line jira/integration/test-id-by-folder-structure
				testId="share-button.ui.pre-share-view.button"
				ref={ref}
				aria-haspopup="dialog"
				{...props}
			>
				{text}
			</Button>
		);
	},
);
